import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import Grid from '@/global/components/ui/Grid'
import { FormField } from 'global/components/Form'

export function DadosResponsavel() {
    return (
        <section id="dados-responsavel">
            <HorizontalDivider className="my-4 select-none">
                Dados do responsável
            </HorizontalDivider>
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <FormField
                        name="nomeResponsavel"
                        label="Nome do responsável"
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField name="email" label="E-mail" required />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        name="cpfResponsavel"
                        label="CPF"
                        placeholder="000.000.000-00"
                        required
                        options={{
                            blocks: [3, 3, 3, 2],
                            delimiters: ['.', '.', '-'],
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        name="telefoneResponsavel"
                        label="Telefone do responsável"
                        required
                        type="tel"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        name="telefone"
                        label="Telefone p/ contato"
                        type="tel"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        name="celular"
                        label="Telefone adicional"
                        type="tel"
                    />
                </Grid>
            </Grid>
        </section>
    )
}
